import React from "react"

export default({children}) => (
    <div className="container container-title">
        <h2 className="title">{children}</h2>
    </div>
)